import { createAction } from '@reduxjs/toolkit';

const setCreatePartTypeModalState = createAction('setCreatePartTypeModalState');
export default setCreatePartTypeModalState;
